import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Input, Label, FormGroup } from "reactstrap";
import BizinBackend from "../../../../helpers/bizin_helper";
import useGetCsrfToken from "../../../../Hooks/useGetCsrfToken";
import { useContext } from "react";
import { DF_OT0059Context } from "../context";
import { Checkbox } from "primereact/checkbox";
import useGetHeightPage from "../../../../Hooks/useGetHeightPage";

const inputClassName = "rounded font-size-14 border-color-cinza2";

function GridBody() {
  const { access_token } = useSelector((state) => ({
    access_token: state.login.user.access_token,
  }));

  const csrfToken = useGetCsrfToken();
  useGetHeightPage();

  const { navigate, location } = useContext(DF_OT0059Context);

  const searchParams = new URLSearchParams(location.search);

  const idEmpresa = searchParams.get("ID_Empresa");
  const idLocalEntrega = searchParams.get("ID_Local_Entrega");
  const idLocalDesembarque = searchParams.get("ID_Local_Desembarque");

  const [deliveryTypes, setDeliveryTypes] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [categories, setCategories] = useState([]);

  const [formData, setFormData] = useState({
    descricao: "",
    quantidadeVolumeDiario: "",
    valorMercadoriaDiario: "",
    pesoBrutoDiario: "",
    quantidadeVeiculosDiario: "",
    quantidadeVolumeEntrega: "",
    valorMercadoriaEntrega: "",
    pesoBrutoEntrega: "",
    diasAntecedenciaAgendamento: "",
    unidadeAgendamento: "",
    dataEncerramento: "",
    limiteAgendamentosParceiro: "",
    tipoEntrega: "",
    permitirMesmoTipoEntrega: false,
  });

  const formatDate = (value) => {
    if (!value) {
      return "";
    }

    return String(value).split("T")[0];
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        const [
          unloadingLocationResponse,
          deliveryTypesResponse,
          /* vehiclesResponse, */
          /* categoriesResponse, */
          selectedVehiclesResponse,
          selectedCategoriesResponse,
        ] = await Promise.all([
          BizinBackend.executeProcedure(
            {
              1: idEmpresa,
              2: idLocalEntrega,
              3: idLocalDesembarque,
            },
            "FRONT_Agendamento_Obter_Lista_Locais_Desembarque",
            csrfToken,
            access_token,
          ),

          BizinBackend.executeProcedure(
            {
              1: idEmpresa,
            },
            "FRONT_Workspace_Lista_Tipo_Entrega",
            csrfToken,
            access_token,
          ),

          BizinBackend.executeProcedure(
            {
              1: idLocalDesembarque,
            },
            "FRONT_Workspace_DF_OT0055_Lista_Veiculos",
            csrfToken,
            access_token,
          ),
          BizinBackend.executeProcedure(
            {
              1: idEmpresa,
              2: idLocalDesembarque,
            },
            "FRONT_Workspace_DF_OT0055_Lista_Categorias",
            csrfToken,
            access_token,
          ),
        ]);

        if (Array.isArray(deliveryTypesResponse)) {
          setDeliveryTypes(deliveryTypesResponse);
        }

        if (Array.isArray(selectedVehiclesResponse)) {
          setVehicles(selectedVehiclesResponse);
        }

        if (Array.isArray(selectedCategoriesResponse)) {
          setCategories(selectedCategoriesResponse);
        }

        const unloadingLocation = Array.isArray(unloadingLocationResponse)
          ? unloadingLocationResponse[0]
          : unloadingLocationResponse;

        if (!unloadingLocation) {
          return;
        }

        setFormData({
          descricao: unloadingLocation.Descricao_Local_Desembarque ?? "",

          quantidadeVolumeDiario:
            unloadingLocation.Limite_Diario_Max_Volumes ?? "",

          valorMercadoriaDiario:
            unloadingLocation.Limite_Diario_Max_Valor ?? "",

          pesoBrutoDiario: unloadingLocation.Limite_Diario_Max_Peso ?? "",

          quantidadeVeiculosDiario:
            unloadingLocation.Limite_Diario_Max_Veiculos ?? "",

          quantidadeVolumeEntrega:
            unloadingLocation.Limite_Entrega_Max_Volumes ?? "",

          valorMercadoriaEntrega:
            unloadingLocation.Limite_Entrega_Max_Valor ?? "",

          pesoBrutoEntrega: unloadingLocation.Limite_Entrega_Max_Peso ?? "",

          diasAntecedenciaAgendamento:
            unloadingLocation.Limite_Max_Dias_Para_Agendar ?? "",

          unidadeAgendamento:
            unloadingLocation.Unidade_Agendamento_Minutos ?? "",

          dataEncerramento: formatDate(unloadingLocation.Data_Encerramento),

          limiteAgendamentosParceiro:
            unloadingLocation.Limite_Agendamentos_Diarios_Parceiro ?? "",

          tipoEntrega:
            unloadingLocation.ID_Tipo_Entrega ??
            unloadingLocation.Id_Tipo_Entrega ??
            "",

          permitirMesmoTipoEntrega:
            unloadingLocation.Permitir_Agendamento_Tipo_Entrega === "S",
        });
      } catch (error) {
        console.error("Error loading unloading location data:", error);
      }
    };

    if (
      csrfToken &&
      access_token &&
      idEmpresa &&
      idLocalEntrega &&
      idLocalDesembarque
    ) {
      loadData();
    }
  }, [csrfToken, access_token, idEmpresa, idLocalEntrega, idLocalDesembarque]);

  return (
    <div className="form-default-primary df-ot0055-page p-0">
      <div className="mb-3">
        <Row className="gx-3 mb-3">
          <Col lg={4}>
            <FormGroup className="mb-2">
              <Label for="descricao">Descrição</Label>

              <Input
                type="text"
                id="descricao"
                value={formData.descricao}
                disabled
                className={inputClassName}
              />
            </FormGroup>
          </Col>

          <Col lg={4}>
            <FormGroup className="mb-2">
              <Label for="quantidadeVolumeDiario">
                Quantidade Volume Diário (Máx)
              </Label>

              <Input
                type="number"
                id="quantidadeVolumeDiario"
                value={formData.quantidadeVolumeDiario}
                disabled
                className={inputClassName}
              />
            </FormGroup>
          </Col>

          <Col lg={4}>
            <FormGroup className="mb-2">
              <Label for="valorMercadoriaDiario">
                Valor da Mercadoria Diário (Máx)
              </Label>

              <Input
                type="number"
                id="valorMercadoriaDiario"
                value={formData.valorMercadoriaDiario}
                disabled
                className={inputClassName}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row className="gx-3 mb-3">
          <Col lg={4}>
            <FormGroup className="mb-2">
              <Label for="pesoBrutoDiario">Peso Bruto em KG Diário (Máx)</Label>

              <Input
                type="number"
                id="pesoBrutoDiario"
                value={formData.pesoBrutoDiario}
                disabled
                className={inputClassName}
              />
            </FormGroup>
          </Col>

          <Col lg={4}>
            <FormGroup className="mb-2">
              <Label for="quantidadeVeiculosDiario">
                Quantidade Veículos Diário (Máx)
              </Label>

              <Input
                type="number"
                id="quantidadeVeiculosDiario"
                value={formData.quantidadeVeiculosDiario}
                disabled
                className={inputClassName}
              />
            </FormGroup>
          </Col>

          <Col lg={4}>
            <FormGroup className="mb-2">
              <Label for="quantidadeVolumeEntrega">
                Quantidade Volume Por Entrega (Máx)
              </Label>

              <Input
                type="number"
                id="quantidadeVolumeEntrega"
                value={formData.quantidadeVolumeEntrega}
                disabled
                className={inputClassName}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row className="gx-3 mb-3">
          <Col lg={4}>
            <FormGroup className="mb-2">
              <Label for="valorMercadoriaEntrega">
                Valor da Mercadoria Por Entrega (Máx)
              </Label>

              <Input
                type="number"
                id="valorMercadoriaEntrega"
                value={formData.valorMercadoriaEntrega}
                disabled
                className={inputClassName}
              />
            </FormGroup>
          </Col>

          <Col lg={4}>
            <FormGroup className="mb-2">
              <Label for="pesoBrutoEntrega">
                Peso Bruto em KG Por Entrega (Máx)
              </Label>

              <Input
                type="number"
                id="pesoBrutoEntrega"
                value={formData.pesoBrutoEntrega}
                disabled
                className={inputClassName}
              />
            </FormGroup>
          </Col>

          <Col lg={4}>
            <FormGroup className="mb-2">
              <Label for="diasAntecedenciaAgendamento">
                Dias de Antecedência para Agendamento
              </Label>

              <Input
                type="number"
                id="diasAntecedenciaAgendamento"
                value={formData.diasAntecedenciaAgendamento}
                disabled
                className={inputClassName}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row className="gx-3 mb-3">
          <Col lg={4}>
            <FormGroup className="mb-2">
              <Label for="unidadeAgendamento">
                Und. para Agendamento em min.
              </Label>

              <Input
                type="number"
                id="unidadeAgendamento"
                value={formData.unidadeAgendamento}
                disabled
                className={inputClassName}
              />
            </FormGroup>
          </Col>

          <Col lg={4}>
            <FormGroup className="mb-2">
              <Label for="dataEncerramento">Data de Encerramento</Label>

              <Input
                type="date"
                id="dataEncerramento"
                value={formData.dataEncerramento}
                disabled
                className={inputClassName}
              />
            </FormGroup>
          </Col>

          <Col lg={4}>
            <FormGroup className="mb-2">
              <Label for="limiteAgendamentosParceiro">
                Limite de Agendamentos Diários por Parceiro
              </Label>

              <Input
                type="number"
                id="limiteAgendamentosParceiro"
                value={formData.limiteAgendamentosParceiro}
                disabled
                className={inputClassName}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row className="gx-3 mb-3 align-items-end">
          <Col lg={4}>
            <FormGroup className="mb-3">
              <Label for="tipoEntrega">Tipo de Entrega</Label>

              <Input
                type="select"
                id="tipoEntrega"
                value={formData.tipoEntrega}
                disabled
                className={inputClassName}
              >
                <option value="">Selecione</option>

                {deliveryTypes.map((type) => (
                  <option
                    key={type.ID_Tipo_Entrega}
                    value={type.ID_Tipo_Entrega}
                  >
                    {type.Descricao_Entrega}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>

          <Col lg={8}>
            <FormGroup className="mb-2">
              <Label
                htmlFor="permitirMesmoTipoEntrega"
                className="d-flex align-items-center mb-3 font-size-13 text-muted"
              >
                <Checkbox
                  inputId="permitirMesmoTipoEntrega"
                  checked={formData.permitirMesmoTipoEntrega}
                  disabled
                />

                <span className="ms-2">
                  Permitir Agendamentos para mesmo tipo de entrega
                </span>
              </Label>
            </FormGroup>
          </Col>
        </Row>
      </div>

      <Row className="gx-3 mt-0">
        <Col lg={6}>
          <div className="checkbox-container shadow-card">
            <h5 className="checkbox-container-title">Selecione os Veículos</h5>

            <div className="checkbox-scroll">
              {vehicles.map((vehicle) => (
                <FormGroup key={vehicle.ID_Veiculo} className="mb-2">
                  <Label
                    htmlFor={`vehicle-${vehicle.ID_Veiculo}`}
                    className="d-flex align-items-center mb-3 font-size-12"
                  >
                    <Checkbox
                      inputId={`vehicle-${vehicle.ID_Veiculo}`}
                      checked={vehicle.Disponivel === "X"}
                      disabled
                    />

                    <span className="ms-2">{vehicle.Descricao_Veiculo}</span>
                  </Label>
                </FormGroup>
              ))}
            </div>
          </div>
        </Col>

        <Col lg={6}>
          <div className="checkbox-container shadow-card">
            <h5 className="checkbox-container-title">
              Selecione as Categorias
            </h5>

            <div className="checkbox-scroll">
              {categories.map((category) => (
                <FormGroup key={category.ID_Categoria} className="mb-2">
                  <Label
                    htmlFor={`category-${category.ID_Categoria}`}
                    className="d-flex align-items-center mb-3 font-size-12"
                  >
                    <Checkbox
                      inputId={`category-${category.ID_Categoria}`}
                      checked={category.Disponivel === "X"}
                      disabled
                    />

                    <span className="ms-2">{category.Descricao}</span>
                  </Label>
                </FormGroup>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default GridBody;
